import common from "@utils/i18n/fr/common.json";
import buttons from "@utils/i18n/fr/buttons.json";
import features from "@utils/i18n/fr/features.json";
import account from "@utils/i18n/fr/account.json";
import alertPreferences from "@utils/i18n/fr/alertPreferences.json";
import api from "@utils/i18n/fr/api.json";
import banners from "@utils/i18n/fr/banners.json";
import cgu from "@utils/i18n/fr/cgu.json";
import components from "@utils/i18n/fr/components.json";
import contacts from "@utils/i18n/fr/contacts.json";
import cookies from "@utils/i18n/fr/cookies.json";
import duplicated from "@utils/i18n/fr/duplicated.json";
import editor from "@utils/i18n/fr/editor.json";
import error from "@utils/i18n/fr/error.json";
import errorPage from "@utils/i18n/fr/errorPage.json";
import footer from "@utils/i18n/fr/footer.json";
import forms from "@utils/i18n/fr/forms.json";
import header from "@utils/i18n/fr/header.json";
import home from "@utils/i18n/fr/home.json";
import images from "@utils/i18n/fr/images.json";
import imports from "@utils/i18n/fr/imports.json";
import login from "@utils/i18n/fr/login.json";
import logout from "@utils/i18n/fr/logout.json";
import modals from "@utils/i18n/fr/modals.json";
import offices from "@utils/i18n/fr/offices.json";
import officeTransfer from "@utils/i18n/fr/officeTransfer.json";
import onboarding from "@utils/i18n/fr/onboarding.json";
import process from "@utils/i18n/fr/process.json";
import resources from "@utils/i18n/fr/resources.json";
import scellement from "@utils/i18n/fr/scellement.json";
import signature from "@utils/i18n/fr/signature.json";
import success from "@utils/i18n/fr/success.json";
import table from "@utils/i18n/fr/table.json";
import transaction from "@utils/i18n/fr/transaction.json";
import users from "@utils/i18n/fr/users.json";

const coreTranslationFR = {
  ...account,
  ...alertPreferences,
  ...api,
  ...banners,
  ...cgu,
  ...components,
  ...contacts,
  ...cookies,
  ...duplicated,
  ...editor,
  ...error,
  ...errorPage,
  ...footer,
  ...forms,
  ...header,
  ...home,
  ...images,
  ...imports,
  ...login,
  ...logout,
  ...modals,
  ...offices,
  ...officeTransfer,
  ...onboarding,
  ...process,
  ...resources,
  ...scellement,
  ...signature,
  ...success,
  ...table,
  ...transaction,
  ...users,
};

const translationFR = {
  ...coreTranslationFR,
  ...common,
  ...buttons,
  ...features,
};

export default translationFR;
